import { Suspense, type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from './ErrorBoundary';
import { PageLoader } from '@/components/ui/loading-spinner';

export function LazyPage({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  // A new destination needs its own boundary. React transitions otherwise keep
  // the already-revealed page visible while the next lazy module is pending.
  // Search/filter changes retain the current page and its local state.
  return (
    <ErrorBoundary key={pathname}>
      <Suspense fallback={<PageLoader />}>{children}</Suspense>
    </ErrorBoundary>
  );
}
